/*
  Boton "Agregar" del carrusel de upsells del cart drawer (v2, 25-ago-2026).

  v2: los tiles de productos con varios colores traen un <select> de variante.
      Si el boton no tiene data-variant-id, el id sale del select del mismo tile.

  Notas:
  - Idempotente: el snippet que lo carga se re-renderiza con el drawer, asi que
    el <script src> puede aparecer mas de una vez. El guard evita listeners dobles.
  - Delegacion de eventos en document: sobrevive a cada re-render del drawer sin
    MutationObserver (los observers sobre #CartDrawer ya causaron un loop de
    cart.js en este tema; no se repite el patron).
  - Pide las secciones cart-drawer y cart-icon-bubble en el mismo POST y usa
    CartDrawer.renderContents(), igual que product-form.js de Dawn. Un solo
    request, sin publicar cartUpdate (evita el fetch extra de CartItems.onCartUpdate).
*/
(function () {
  if (window.__cartUpsellsInit) return;
  window.__cartUpsellsInit = true;

  function addUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add';
  }

  function variantId(button) {
    if (button.dataset.variantId) return Number(button.dataset.variantId);
    var tile = button.closest ? button.closest('.cart-upsells__item') : null;
    var select = tile ? tile.querySelector('.cart-upsells__variant') : null;
    return select && select.value ? Number(select.value) : 0;
  }

  document.addEventListener('click', function (event) {
    var button =
      event.target && event.target.closest
        ? event.target.closest('button.cart-upsells__add')
        : null;
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    var id = variantId(button);
    if (!id) return;

    var originalLabel = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Agregando...';

    var body = JSON.stringify({
      items: [{ id: id, quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });

    fetch(addUrl() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          throw new Error(state.description || state.message || 'add failed');
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.renderContents(state);
          return;
        }

        window.location.reload();
      })
      .catch(function () {
        button.textContent = originalLabel;
        button.removeAttribute('aria-busy');
      });
  });
})();
